import React, { useId } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import "@fortawesome/fontawesome-free/css/all.css";
import Link from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Link";
import styles from "./index.module.scss";

function Template({ data }) {
  const {
    title,
    main_image: mainImg,
    text,
    cta_label: ctaLabel,
    cta_link: ctaLink,
    features
  } = data || {};

  const featsColumns = features?.filter((feat) => feat.display);

  return (
    <div className={styles.wrapper}>
      <Grid container>
        <Grid item lg={6} sm={12} xs={12}>
          <img
            className={styles.logo}
            src={mainImg?.publicURL}
            alt="Cloud Infrastructure Diagram"
            width="100%"
          />
        </Grid>
        <Grid item lg={6} sm={12} className={styles.main_right}>
          <Typography variant="h2">{title}</Typography>
          <div
            className={styles.credit}
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <Link to={ctaLink} className={styles.cta}>
            {ctaLabel}
          </Link>
        </Grid>
        <Grid container spacing={3} className={styles.features}>
          {featsColumns.map((feat) => (
            <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              key={useId()}
              className={styles.feature}
            >
              <Link to={feat.link} className={styles.imgLink}>
                <img
                  className={styles.logo}
                  src={feat.image?.publicURL}
                  alt={feat.title}
                />
              </Link>
              <Typography variant="h2">{feat.title}</Typography>
              <Link to={feat.link} className={styles.textLink}>
                {feat.text}
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}

Template.propTypes = {
  data: PropTypes.isRequired
};

export default Template;
